import { render, staticRenderFns } from "./ContainerLibrary.vue?vue&type=template&id=5a2018fc&scoped=true"
import script from "./ContainerLibrary.vue?vue&type=script&lang=ts"
export * from "./ContainerLibrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2018fc",
  null
  
)

export default component.exports